//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../AME/AME.SelectAMEBaseNode.js";
import "../no/SelectObject.js";
import "../no/Tooling.js";
let d=[[[0,"CreationType",1,0],[0,"Description",1,0],[0,"Name",1,0],[1,"Parent",0,"AME.SelectAMEBaseNode",0],[0,"ReuseLibraryItem",0,"Tooling.SelectReuseLibraryItemBuilder",0]],[[[],"GetPublicQueryName",{R_:{name:''}},0,0],[[],"GetPublicQueryDescription",{R_:{description:''}},0,0]],[]];
SPLM.AME.QueryBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.QueryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.QueryBuilder.Types = Object.freeze({
    "NewQuery" : "NewQuery", "FromLibrary" : "FromLibrary"});

export default SPLM;